#import "../fragments/inbox-message-fragment.graphql"

query GetInboxMessage($messageId: ID!) {
    inboxMessage(id: $messageId) {
        ...InboxMessageFragment
    }
}
